import { useState, useEffect, useCallback } from 'react';
import './UpdatePrompt.css';

interface UpdatePromptProps {
  registration: ServiceWorkerRegistration | null;
}

const UpdatePrompt = ({ registration }: UpdatePromptProps) => {
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    if (registration) {
      setShowPrompt(true);
    }
  }, [registration]);

  const handleUpdate = useCallback(() => {
    if (registration && registration.waiting) {
      // Tell the service worker to skip waiting and activate
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });

      // Once the new service worker is activated, reload the page
      // Using { once: true } to ensure the listener is removed after firing
      registration.waiting.addEventListener('statechange', (e: Event) => {
        const sw = e.target as ServiceWorker;
        if (sw.state === 'activated') {
          window.location.reload();
        }
      }, { once: true });
    }
  }, [registration]);

  const handleDismiss = useCallback(() => {
    setShowPrompt(false);
  }, []);

  if (!showPrompt) {
    return null;
  }

  return (
    <div className="update-prompt-overlay">
      <div className="update-prompt">
        <div className="update-prompt-icon">🔄</div>
        <h3 className="update-prompt-title">Update Available</h3>
        <p className="update-prompt-message">
          A new version of the app is available. Update now to get the latest features and improvements.
        </p>
        <div className="update-prompt-buttons">
          <button
            className="update-prompt-button update-prompt-button-later"
            onClick={handleDismiss}
          >
            Later
          </button>
          <button
            className="update-prompt-button update-prompt-button-update"
            onClick={handleUpdate}
          >
            Update Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdatePrompt;
